import { render, staticRenderFns } from "./SithMesInventoryPackageList.vue?vue&type=template&id=35b93cf4&"
import script from "./SithMesInventoryPackageList.vue?vue&type=script&lang=js&"
export * from "./SithMesInventoryPackageList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports